module.exports = __webpack_public_path__ + "img/full4-min.eb4d9817.png";